import React, { useEffect, useState } from "react";
import {epochSeconds, formatDate, getPreferredSynologyFile, getStaticFileUrls, isHidden} from "../utils/Functions";
import Constants from "../utils/Constants";
import {Box, InputLabel, makeStyles, MenuItem, Select, Typography} from "@material-ui/core";
import Grid from '@mui/material/Unstable_Grid2';
import {IconButton, Paper, Stack} from "@mui/material";
import Button from '@mui/material/Button';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import { getAccessToken } from "../utils/Auth";
import axios from "axios";
import Notification from "./Notification";
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import BackspaceOutlinedIcon from "@mui/icons-material/BackspaceOutlined";
import { toast } from "react-toastify";
import DeleteDialog from "./DeleteDialog";
import ViewWeekOutlinedIcon from "@mui/icons-material/ViewWeekOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import ColumnsDialog from "./ColumnsDialog";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import AlertSinkList from "./AlertSiinkList";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import Checkbox from "@mui/material/Checkbox";


const http_str = "https://"
let settings_url = http_str.concat(Constants.apiHost, '.', Constants.domainName,'/api/v1/globals')
let activations_url = http_str.concat(Constants.apiHost, '.', Constants.domainName,'/api/v1/activationkeys')
let files_url = http_str.concat(Constants.apiHost, '.', Constants.domainName,'/api/v1/files')
const stripe_portal = "https://billing.stripe.com/p/login/7sY4gsgifcSB5eCcg0fjG00"
const pricing_url = "https://www.ransomstop.com/pricing"
const release_type = Constants.domainName.endsWith(".com") ? "GA" : "EA" // ransomstop.com -> GA, ransomstop.net -> EA
const backup_release_type = (release_type === 'EA') ? 'GA' : 'EA'

const useStyles = makeStyles(theme => ({
    outer_div: {
        minHeight: '100vh',
    },
    itemBar: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#222222',
    },
    pageBar: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        backgroundColor: '#222222',
        color: '#AAAAAA',
    },
    tableComponent: {
        borderStyle: 'solid',
        borderColor: '#000',
        borderRadius: '10px',
        borderSpacing: '0px',
        borderRightWidth: '0px',
        borderTopWidth: '1px',
        borderBottomWidth: '0px',
        borderLeftWidth: '0px',
        // backgroundColor: '#222222' // setting this breaks row highlighting
    },
    tableCell: {
        paddingLeft: '12px',
    },
    clickableTableCell: {
        paddingLeft: '12px',
        cursor: 'pointer',
    },
    dialog: {
        backgroundColor: '#333333',
        color: '#CCCCCC',
        margin: '10',
    },
    dialogTitleBar: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogConfirm: {
        backgroundColor: '#149616',
        color: '#CCCCCC',
    },
    dialogNeutral: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogWarning: {
        backgroundColor: '#d42842',
        color: '#CCCCCC',
    },
    primaryColor: {
        color: '#000',
        backgroundColor: '#111'
    },
    whiteColor: {
        color: "#EEE",
    },
    redColor: {
        color: "#F00"
    },
    hide: {
        display: 'none',
    },
    spaced: {
        margin: '10px',
    }
}))

const toastOptions = {
    position: "bottom-right",
    autoClose: 6000,
    hideProgressBar: false,
    pauseOnHover: true,
    draggable: true
}

let serial_headers = [
    { field: 'pk', headerName: 'Code', width: 'auto', hidden: false },
    { field: 'created', headerName: 'Created', width: 200, hidden: false},
    { field: 'expiration', headerName: 'Expires', width: 200, hidden: false },
    { field: 'delete', headerName: 'Delete', width: 50, hidden: false },
]

const SANDBOX = 0
const PRODUCTION = 1
const plans = [
    // Stripe sandbox plans and urls
    [
        { 'name': 'Server', 'value': 'Server', 'month': 'https://buy.stripe.com/test_28EdR2e6V1bT62sbb9asg08', 'year': 'https://buy.stripe.com/test_dRm00c1k9bQx4Yo4MLasg09' },

    ],
    // Stripe production plans and urls
    [
        { 'name': 'Server', 'value': 'Server', 'month': 'https://buy.stripe.com/8x2cMYaXVcSB0Ymdk4fjG0h', 'year': 'https://buy.stripe.com/cNieV6d63bOx9uS93OfjG0i' },
        { 'name': 'Hypervisor', 'value': 'Hypervisor', 'month': 'https://buy.stripe.com/bJe7sE9TR7yh9uSfscfjG0j', 'year': 'https://buy.stripe.com/bJecMY1nl4m59uS7ZKfjG0k' },
    ]
]

const periods = [
    { 'name': 'month', 'value': 'Monthly' },
    { 'name': 'year', 'value': 'Yearly (10% off)' }
]

let mode = SANDBOX
if (Constants.domainName === 'ransomstop.com') {
    mode = PRODUCTION
}

export const Settings = () => {
    const classes = useStyles()
    const [codes, setCodes] = useState([])
    const [alerts, setAlerts] = useState([])
    const [alertsRequireSave, setAlertsRequireSave] = useState(false)
    const [selectedItem, setSelectedItem] = useState(null)
    const [selectedRow, setSelectedRow] = useState(null)
    const [columnsMode, setColumnsMode] = useState(false)
    const [addMode, setAddMode] = useState(false)
    const [limit, setLimit] = React.useState(10)
    const [pages, setPages] = useState([0])
    const [pageIndex, setPageIndex] = useState(0)
    const [winInstallerUrl, setWinInstallerUrl] = useState('')
    const [linInstallerUrl, setLinInstallerUrl] = useState('')
    const [synInstallerUrl, setSynInstallerUrl] = useState('')
    const [ransomwareUrl, setRansomwareUrl] = useState('')
    const [isCopied, setIsCopied] = useState(false);
    const [deleteMode, setDeleteMode] = useState(false)
    const [selectedPlan, setSelectedPlan] = useState("ChoosePlan")
    const [selectedPlanPeriod, setSelectedPlanPeriod] = useState("ChoosePeriod")
    const [installAutoUpdate, setInstallAutoUpdate] = useState(true)
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);


    const getPaymentUrl = () => {
        console.log("plan: " + selectedPlan)
        console.log("period: " + selectedPlanPeriod)
        let target_url = ""
        for (let i = 0; i < plans[mode].length; i += 1) {
            if (selectedPlan === plans[mode][i].name) {
                if (selectedPlanPeriod === 'year') {
                    target_url = plans[mode][i]['year'] + '?client_reference_id=' + Constants.apiHost
                    return target_url
                }
                else {
                    target_url = plans[mode][i]['month'] + '?client_reference_id=' + Constants.apiHost
                    return target_url
                }
            }
        }
        return target_url
    }

    const getAlerts = async () => {
        let url = settings_url
        if (pageIndex !== 0) {
            console.log('fetch page: ' + pages[pageIndex])
            url = url + '?limit=' + limit + '&nextPageKey=' + pages[pageIndex]
        }
        else {
            console.log('fetch page: 0')
            url = url + '?limit=' + limit
        }
        const http_headers = { "Content-Type": "application/json","Authorization": await getAccessToken() }
        console.log('url: ' + url)
        await axios
            .get(url, { headers: http_headers })
            .then(res => {
                if (pageIndex === pages.length - 1) {
                    let npk = res.data['nextPageKey']
                    if (npk) {
                        let tmp_arr = pages
                        tmp_arr.push(npk)
                        setPages(tmp_arr)
                    }
                }
                const alerts = res.data['alerts'];
                console.log(alerts);
                setAlerts(alerts)
            })
            .catch(err => {
                if (err.response) {
                  console.log('bad response from server: ' + err.response)
                } else if (err.request) {
                  console.log('no response from server: ' + err.request)
                } else {
                  console.log(err)
                }
                Notification(`Error while fetching ${url}. ${err}`, 'error');
                return Promise.reject(err);
            })
    }

    const saveAlerts = async (alerts) => {
        let url = settings_url
        const http_headers = { 'Content-Type': 'application/json','Authorization': await getAccessToken() }

        // add timestamp
        alerts = alerts.map(alert => ({
            ...alert,
            timestamp: epochSeconds(),
        }));

        let params = { alerts: alerts }
        const toastId = toast.loading('saving Alert Notifications...', toastOptions)
        await axios
            .post(url, { 'settings': params },{ headers: http_headers })
            .then(res => {
                // Add the data submitted back to the local table so it is correct before server side refresh
                toast.update(toastId, {render: `${res.data['msg']}`, type: "success", isLoading: false, autoClose: 2000})
            })
            .catch(err => {
                if (err.response) {
                  console.log('bad response from server: ' + err.response)
                } else if (err.request) {
                  console.log('no response from server: ' + err)
                } else {
                  console.log(err)
                }
                toast.update(toastId, {render: `Error adding Global Alerts: ${err}`, type: "error", isLoading: false, closeButton: true})
            })
    }

    const getCodes = async () => {
        let url = activations_url
        if (pageIndex !== 0) {
            console.log('fetch page: ' + pages[pageIndex])
            url = url + '?limit=' + limit + '&nextPageKey=' + pages[pageIndex]
        }
        else {
            console.log('fetch page: 0')
            url = url + '?limit=' + limit
        }
        const http_headers = { "Content-Type": "application/json","Authorization": await getAccessToken() }
        console.log('url: ' + url)
        await axios
            .get(url, { headers: http_headers })
            .then(res => {
                if (pageIndex === pages.length - 1) {
                    let npk = res.data['nextPageKey']
                    if (npk) {
                        let tmp_arr = pages
                        tmp_arr.push(npk)
                        setPages(tmp_arr)
                    }
                }
                const codes = res.data['codes'];
                console.log(codes);
                setCodes(codes)
            })
            .catch(err => {
                if (err.response) {
                  console.log('bad response from server: ' + err.response)
                } else if (err.request) {
                  console.log('no response from server: ' + err.request)
                } else {
                  console.log(err)
                }
                Notification(`Error while fetching ${url}. ${err}`, 'error');
                return Promise.reject(err);
            })
    }

    const addCode = async () => {
        let url = activations_url
        const http_headers = { 'Content-Type': 'application/json','Authorization': await getAccessToken() }
        const api = Constants.apiHost + '.' + Constants.domainName
        let params = {
            api_url: api
        }
        const toastId = toast.loading('Generating new Serial Number...', toastOptions)
        await axios
            .post(url, { 'activation_code': params },{ headers: http_headers })
            .then(res => {
                // Add the data submitted back to the local table so it is correct before server side refresh
                params.pk = res.data['pk']
                params.created = epochSeconds()
                setCodes(codes.concat([params]))
                toast.update(toastId, {render: `${res.data['msg']}`, type: "success", isLoading: false, autoClose: 2000})
                // Notification(res.data['msg'], 'info');
                getCodes()
            })
            .catch(err => {
                if (err.response) {
                  console.log('bad response from server: ' + err.response)
                } else if (err.request) {
                  console.log('no response from server: ' + err)
                } else {
                  console.log(err)
                }
                toast.update(toastId, {render: `Error generating new Serial Number: ${err}`, type: "error", isLoading: false, closeButton: true})
                // Notification(`Error: adding new site. ${err}`, 'error');
            })
    }

    const deleteCode = async (uuid) => {
        let url = activations_url + "/" + uuid
        const headers = { 'Content-Type': 'application/json','Authorization': await getAccessToken() }
        const toastId = toast.loading('deleting Serial Number...', toastOptions)
        await axios
            .delete(url, { headers: headers })
            .then(res => {
                console.log(res.data);
                let items_filtered = codes.map((x) => x)
                items_filtered = items_filtered.filter(i => i.pk !== uuid)
                setCodes(items_filtered)
                toast.update(toastId, {render: `${res.data['msg']}`, type: "success", isLoading: false, autoClose: 2000})
            })
            .catch(err => {
                if (err.response) {
                  console.log('bad response from server: ' + err.response)
                } else if (err.request) {
                  console.log('no response from server: ' + err)
                } else {
                  console.log(err)
                }
                toast.update(toastId, {render: `Error deleting: ${err}`, type: "error", isLoading: false, closeButton: true})
                return Promise.reject(err);
            })
    }

    const saveInstallSettings = async (enabled) => {
        let url = settings_url
        const http_headers = { 'Content-Type': 'application/json','Authorization': await getAccessToken() }
        let params = {
            auto_update: enabled
        }
        const toastId = toast.loading('saving Auto Update setting...', toastOptions)
        await axios
            .post(url, { 'settings': params },{ headers: http_headers })
            .then(res => {
                // Add the data submitted back to the local table so it is correct before server side refresh
                toast.update(toastId, {render: `${res.data['msg']}`, type: "success", isLoading: false, autoClose: 2000})
            })
            .catch(err => {
                if (err.response) {
                  console.log('bad response from server: ' + err.response)
                } else if (err.request) {
                  console.log('no response from server: ' + err)
                } else {
                  console.log(err)
                }
                toast.update(toastId, {render: `Error saving Auto Update setting: ${err}`, type: "error", isLoading: false, closeButton: true})
            })
    }

    const handleCopyCode = async (e, activation_code) => {
        // console.log(JSON.stringify(e))
        const toastId = toast.loading('copying Serial Number...', toastOptions)
        try {
            if (activation_code === 'undefined') {
                toast.update(toastId, {render: `copied serial number`, type: "success", isLoading: false, autoClose: 1000})
            }
            await navigator.clipboard.writeText(activation_code);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
            toast.update(toastId, {render: `copied serial number`, type: "success", isLoading: false, autoClose: 1000})
        } catch (error) {
            console.error("Failed to copy text: ", error);
        }
    };

    const handleOpenColumns = () => {
        setColumnsMode(true);
    };

    const handleCloseColumns = () => {
        setColumnsMode(false);
    };

    const handleOpenDelete = (e, uuid) => {
        // stopPropagation seems to block selecting and editing a row in 1 click, so remove it if it doesn't cause any other issues
        //e.stopPropagation()
        setSelectedRow(uuid)
        const item = codes.find(item => item.pk === uuid);
        setSelectedItem(item)
        setDeleteMode(true);
        console.log("delete " + selectedRow)
    };

    const handleDelete = (uuid) => {
        deleteCode(uuid)
        setDeleteMode(false);
    };

    const handleCloseDelete = () => {
        setDeleteMode(false);
    };

    const handleLimit = (event) => {
        setLimit(event.target.value);
        setPages([0])
        setPageIndex(0)
    };

    const handlePreviousPage = () => {
        if (pageIndex > 0) {
            setPageIndex(pageIndex - 1)
        }
    }

    const handleNextPage = () => {
        if (pageIndex < pages.length - 1) {
            setPageIndex(pageIndex + 1)
        }
    }

    const handleSerialAdd = () => {
        //let addData = addItem(formData)
        // check addData for error and notify user
        //setAddMode(false)
         addCode()
    }

    const handleAlertAdd = () => {
        console.log("got AddAlert event")
        const new_alert = {"alert_type": "", "enabled": true, "inherited": false, "inherited_from": "", "internal": false}
        alerts.unshift(new_alert)
        setAlertsRequireSave(true)
    }

    const handleAlertChange = (index, event) => {
        let {name, value} = event.target
        //console.log("alert index: " + index)
        //console.log("handleAlertChange: " + name + ": " + value)
        const items_length = alerts.length;
        if (index >= 0  && index < items_length) {
            // convert comma-seperated list into array
            if (name === 'recipients') {
                value = value.split(",")
            }
            var newAlerts = [...alerts]
            let newAlert = {...newAlerts[index]}
            newAlert = {...newAlert, [name]: value}
            newAlerts[index] = newAlert
            setAlerts(newAlerts)
        }
        setAlertsRequireSave(true)
    };

    const handleAlertInternalChange = (index, event) => {
        let checked = event.target.checked
        const items_length = alerts.length;
        if (index >= 0  && index < items_length) {
            var newAlerts = [...alerts]
            let newAlert = {...newAlerts[index]}
            if (newAlert.alert_type === "Email") {
                newAlert.internal = false
            } else if (newAlert.alert_type === "Slack") {
                newAlert.internal = false
            } else {
                newAlert = {...newAlert, "internal": checked};
            }
            newAlerts[index] = newAlert
            setAlerts(newAlerts)
        }
        setAlertsRequireSave(true)
    };

    const handleAlertDelete = (index) => {
        console.log("handleAlertDelete: " + index)
        const items_length = alerts.length;
        if (index >= 0 && index < items_length) {
            alerts.splice(index, 1);
        }
        setAlertsRequireSave(true)
    };

    const handleAlertSave = () => {
        saveAlerts(alerts)
    }

    const handlePlanChange = (event) => {
      setSelectedPlan(event.target.value);
    };

    const handlePlanPeriodChange = (event) => {
      setSelectedPlanPeriod(event.target.value);
    };

    const handleCheckboxChange = (event) => {
        const { name } = event.target
        console.log(name + ": " + event.target.checked)
        if (name === 'autoupdate') {
            setInstallAutoUpdate(event.target.checked)
            saveInstallSettings(event.target.checked)
        }

	};

    const toggleSerialColumn = (event) => {
        for (let i = 0; i < serial_headers.length; i++) {
            if (serial_headers[i]['field'] === event.target.id) {
                serial_headers[i]['hidden'] = !serial_headers[i]['hidden']
            }
        }
        //  ugly but since the checkboxes aren't tied to state, they are tied to column definitions, they don't update
        forceUpdate()
    };

    const isExpired = (exp_date) => {
        if (exp_date < Math.floor(Date.now() / 1000)) {
            return true
        }
        else {
            return false
        }
    }

    const sandboxLabel = () => {
        if (mode === SANDBOX) {
            return (
                <div style={{backgroundColor: '#ff0000', padding: '5px'}}>
                    <Typography variant="h6" color="red" align="center">SANDBOX MODE - NO REAL TRANSACTIONS</Typography>
                </div>
            )
        } else {
            return ''
        }
    }

    const getBillingSection = () => {
        if (Constants.showBilling === true) {
            return (
                <>
                {sandboxLabel()}
                    <p>Pay bill or setup scheduled billing</p>
                    <Stack direction={"row"} spacing={10}>
                        <Select
                            classes={{root: classes.whiteColor, icon: classes.whiteColor}}
                            labelId="subscription-plan"
                            id="subscription-plan"
                            value={selectedPlan}
                            label="Plan"
                            onChange={handlePlanChange}
                        >
                            <MenuItem value={"ChoosePlan"}>-- Choose Plan --</MenuItem>
                            {plans[mode].map((item) =>
                                <MenuItem key={item.name} value={item.name}>{item.value}</MenuItem>)}
                        </Select>
                        <Select
                            classes={{root: classes.whiteColor, icon: classes.whiteColor}}
                            labelId="subscription-plan-period"
                            id="subscription-plan-period"
                            value={selectedPlanPeriod}
                            label="Period"
                            onChange={handlePlanPeriodChange}
                        >
                            <MenuItem value={"ChoosePeriod"}>-- Choose Period --</MenuItem>
                            {periods.map((item) =>
                                <MenuItem key={item.name} value={item.name}>{item.value}</MenuItem>)}
                        </Select>
                        <Button className={classes.dialogConfirm}
                                onClick={() => window.open(getPaymentUrl(), '_blank', 'noopener,noreferrer')}
                                variant="contained" startIcon={<AttachMoneyOutlinedIcon/>}>PAY</Button>
                        <Button className={classes.dialogConfirm}
                                onClick={() => window.open(stripe_portal, '_blank', 'noopener,noreferrer')}
                                variant="contained" startIcon={<LoginOutlinedIcon/>}>Stripe</Button>
                        <Button className={classes.dialogConfirm}
                                onClick={() => window.open(pricing_url, '_blank', 'noopener,noreferrer')}
                                variant="contained" startIcon={<LoginOutlinedIcon/>}>Price List</Button>
                    </Stack>
                </>
            )
        }
        else {
            return (
                <>
                    <p>Online billing is disabled for this tenant.</p>
                </>
            )
        }
    }

    const getCopyButton = (pk, expiration) => {
        if (isExpired(expiration)) {
            return (
                <Button variant="outlined" color="error" size="small">EXPIRED</Button>
            )
        }
        else {
            return (
                <ContentCopyOutlinedIcon color={"primary"}
                    onClick={(e) => handleCopyCode(e, pk)}
                     style={{verticalAlign: "bottom"}} />
            )
        }
    }

    const fetchInstallerWithFallback = async (file_prefix, setter) => {
        let resolved = '';
        // first try primary
        await getStaticFileUrls(
            `installers/latest/${file_prefix}_latest_${release_type}.zip`,
            (u) => { resolved = u; setter(u); },
            'source=global'
        );
        // fallback only if still empty
        if (!resolved) {
            await getStaticFileUrls(
                `installers/latest/${file_prefix}_latest_${backup_release_type}.zip`,
                setter,
                'source=global'
            );
        }
    };

    useEffect(() => {
        getCodes();

        fetchInstallerWithFallback('installer-gui-windows', setWinInstallerUrl);
        fetchInstallerWithFallback('installer-cli-linux', setLinInstallerUrl);

        getPreferredSynologyFile(setSynInstallerUrl, release_type);
        getStaticFileUrls('RansomwareSimulator.exe', setRansomwareUrl);
        getAlerts();

    }, []);

    return (
        <div className={classes.outer_div} style={{padding: '20px'}}>
            <Paper variant="outlined" style={{padding: '15px'}}>
                <Accordion>
                    <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    >
                        Global
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item xs={11} className={classes.inputRow}>
                                <Stack direction={"row"} justifyContent={"space-between"}>
                                    <Typography variant="h4">Configuration</Typography>
                                </Stack>
                            </Grid>
                            <Stack className={classes.inputRow}
                               elevation={0}
                               direction="row"
                               alignItems="center"
                               sx={{width: 1, height: "5vh"}}
                            >
                                <InputLabel className={classes.dialog}>Auto Update</InputLabel>
                                <Checkbox
                                    name='autoupdate'
                                    label='Auto Update'
                                    checked={installAutoUpdate}
                                    onChange={handleCheckboxChange}
                                    variant={"outlined"}
                                    className={classes.dialog}
                                    classes={{ root: classes.whiteColor, icon: classes.whiteColor }}
                                    style={{minWidth: 55}}
                                />
                            </Stack>
                            <Grid>&nbsp;</Grid>
                        </Grid>
                    </AccordionDetails>
                    <AccordionActions>
                    </AccordionActions>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel2-content"
                        id="panel2-header"
                    >
                        Billing
                    </AccordionSummary>
                    <AccordionDetails>
                        {getBillingSection()}
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel3-content"
                        id="panel3-header"
                    >
                        Installation
                    </AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Serial Numbers are required for installation on Windows servers and Synology
                                NAS appliances
                            </li>
                            <li>Copy the Serial Number below and paste into the Installer when prompted</li>
                            <li>If there are no valid Serial Numbers listed, use the <AddOutlinedIcon className={classes.spaced}
                                    color={"primary"} style={{verticalAlign: "bottom"}} /> at the top right
                                of the Serial Numbers list to add a new Serial Number
                            </li>
                        </ul>
                        <Stack direction={"row"} justifyContent={"space-between"}>
                            <Typography variant="h4">Serial Numbers</Typography>
                            <Box>
                                <ViewWeekOutlinedIcon className={classes.spaced} color={"primary"}
                                                      onClick={() => handleOpenColumns()}/>
                                <AddOutlinedIcon className={classes.spaced} color={"primary"}
                                                 onClick={() => handleSerialAdd()}/>
                            </Box>
                        </Stack>
                        {/* TABLE */}
                        <table className={classes.tableComponent} style={{width: 100 + "%"}}>
                            <thead>
                            <tr className={classes.tableComponent}>
                                {serial_headers.map(header => (
                                    <th width={header.width}
                                        className={header.hidden === true ? classes.hide : ''}>{header.headerName}</th>
                                ))}
                            </tr>
                            </thead>
                            <tbody className={classes.tableComponent}>
                            {codes.map(val =>
                                <tr key={val.pk} className={classes.tableComponent}
                                    style={{color: isExpired(val.expiration) ? '#d00429' : 'white'}}>
                                    <td className={isHidden('pk', serial_headers) ? classes.hide : classes.tableCell}>{val.pk}&nbsp;&nbsp;
                                        {getCopyButton(val.pk, val.expiration)}
                                    </td>
                                    <td className={isHidden('created', serial_headers) ? classes.hide : classes.tableCell}>{formatDate(val.created)}</td>
                                    <td className={isHidden('expiration', serial_headers) ? classes.hide : classes.tableCell}>{formatDate(val.expiration)}</td>
                                    <td className={isHidden('delete', serial_headers) ? classes.hide : classes.clickableTableCell}>
                                        <BackspaceOutlinedIcon color={"error"}
                                                               onClick={(e) => handleOpenDelete(e, val.pk)}/>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                        <Paper className={classes.itemBar} elevation={1}>
                            <Stack className={classes.pageBar}
                                   elevation={0}
                                   direction="row"
                                   alignItems="center"
                                   sx={{width: 1, height: "5vh"}}>
                                <IconButton onClick={() => getCodes()}><RefreshOutlinedIcon
                                    className={classes.spaced}/></IconButton>
                                <Typography className={classes.spaced}>Rows per page:</Typography>
                                <Select
                                    classes={{root: classes.whiteColor, icon: classes.whiteColor}}
                                    labelId="fetch-limit-select"
                                    id="fetch-limit-select"
                                    value={limit}
                                    label="Limit"
                                    onChange={handleLimit}
                                >
                                    <MenuItem value={10}>10</MenuItem>
                                    <MenuItem value={25}>25</MenuItem>
                                    <MenuItem value={50}>50</MenuItem>
                                </Select>
                                <IconButton disabled={pageIndex === 0} onClick={() => handlePreviousPage()}><ChevronLeftOutlinedIcon/></IconButton>
                                <Typography variant={'h6'}>{pageIndex + 1}</Typography>
                                <IconButton disabled={pageIndex >= pages.length - 1}
                                            onClick={() => handleNextPage()}><ChevronRightOutlinedIcon/></IconButton>
                            </Stack>
                        </Paper>
                        <p>For installation on other platforms, use the Deploy button from the <a
                            href='/analyzers'
                            target='_blank"'>Analyzers tab<OpenInNewOutlinedIcon
                            style={{verticalAlign: "bottom"}}/></a>, or <a
                            href='https://support.ransomstop.com' target='_blank"'>check
                            our documentation<OpenInNewOutlinedIcon
                                style={{verticalAlign: "bottom"}}/></a> for the specific platform</p>
                    </AccordionDetails>
                    <AccordionActions>
                        <Button className={classes.dialogConfirm}
                                onClick={() => window.open(synInstallerUrl, '_blank')}
                                disabled={synInstallerUrl === '' ? true : false} variant="contained"
                                startIcon={<CloudDownloadOutlinedIcon/>}>SYNOLOGY INSTALLER</Button>
                        <Button className={classes.dialogConfirm}
                                onClick={() => window.open(linInstallerUrl, '_blank')}
                                disabled={linInstallerUrl === '' ? true : false} variant="contained"
                                startIcon={<CloudDownloadOutlinedIcon/>}>LINUX INSTALLER</Button>
                        <Button className={classes.dialogConfirm}
                                onClick={() => window.open(winInstallerUrl, '_blank')}
                                disabled={winInstallerUrl === '' ? true : false} variant="contained"
                                startIcon={<CloudDownloadOutlinedIcon/>}>WINDOWS INSTALLER</Button>
                    </AccordionActions>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel3-content"
                        id="panel3-header"
                    >
                        Alert Notifications
                    </AccordionSummary>
                    <AccordionDetails className={classes.dialog}>
                        <Typography variant='subtitle2' className={classes.dialogWidget} component={'span'}>
                            Alerts can be set here globally, or can be set at the Site or Analyzer levels.
                        </Typography>
                        <AlertSinkList
                            parent="global"
                            alert_source="global"
                            alerts={alerts}
                            handleAlertAdd={handleAlertAdd}
                            handleAlertChange={handleAlertChange}
                            handleAlertInternalChange={handleAlertInternalChange}
                            handleAlertDelete={handleAlertDelete}
                            requireSave={alertsRequireSave}
                            setRequireSave={setAlertsRequireSave}/>
                    </AccordionDetails>
                    <AccordionActions>
                        <Button className={classes.dialogConfirm} onClick={() => handleAlertSave()}
                                disabled={!alertsRequireSave} variant="contained"
                                startIcon={<CheckBoxOutlinedIcon/>}>SAVE</Button>
                    </AccordionActions>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel4-content"
                        id="panel4-header"
                    >
                        Extras
                    </AccordionSummary>
                    <AccordionDetails>
                        <p>Downloadable Files</p>
                    </AccordionDetails>
                    <AccordionActions>
                        <Button className={classes.dialogConfirm}
                                onClick={() => window.open(ransomwareUrl, '_blank')}
                                disabled={ransomwareUrl === '' ? true : false} variant="contained"
                                startIcon={<CloudDownloadOutlinedIcon/>}>RANSOMWARE SIMULATOR</Button>
                    </AccordionActions>
                </Accordion>
                {/* DIALOGS */}
                {/* COLUMNS DIALOG */}
                <ColumnsDialog
                    variant={"outlined"}
                    open={columnsMode}
                    onClose={handleCloseColumns}
                    onChange={toggleSerialColumn}
                    headers={serial_headers}
                />
                {/* DELETE DIALOG */}
                <DeleteDialog
                    open={deleteMode}
                    onClose={handleCloseDelete}
                    onDelete={handleDelete}
                    //formData={formData}
                    //setFormData={setFormData}
                    type={'code'}
                    row={selectedRow}
                    item={selectedItem}
                />
            </Paper>
        </div>
    )
}
